/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  GridC,
  TextC,
//  _61v,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';

const IccvFtr = () => {
  return (
    cr.c(GridC.N, {
      key: 'Ftr.root',
      abtType: 'ftrBarCmnz',
      lineCs: [
        {
          cellCs: [
            {
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'crtCmnz',
                  textz: {
                    pfx: 'Fサポート 部屋予約システム',
                  }
                })
              ],
            }
          ]
        }
      ]
    })
  );
};
export default IccvFtr;
